<script>
import ModuleTitle from '../common/ModuleTitle.vue'

import { getShadowColor, getPageThemeColor } from '@/utils/modules/getStyles'
import { richTextImgHandler } from '@/utils/common'
import { hiddenPhone } from '@/utils/filters'

export default {
  name: 'Comp59',
  components: { ModuleTitle },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path,
      admini: localStorage.getItem('admini'),
      pageData: []
    }
  },
  created() {
    this.dataValued()
  },
  methods: {
    getShadowColor, getPageThemeColor, richTextImgHandler,
    hiddenPhone,
    onModuleItem(v) {
      this.$emit('onModuleItem', v)
    },
    dataValued() {
      this.pageData = this.moduleOption?.list || []
      this.pageData.length > 0 && this.pageData.forEach(item => {
        this.$set(item, 'phoneShow', false)
      })
    },
    onPhoneHidden(v) {
      this.pageData.forEach(item => {
        if (item.id === v.id) item.phoneShow = !item.phoneShow
      })
    }
  }
}
</script>

<template>
  <div class="modules-id-59">
    <module-title :title="moduleOption.title" margin-bottom="24" />
    <div class="comp-transverse-2 modules-id-59-content pointer">
      <div
        v-for="(v, i) in pageData.slice(0, 4)"
        :key="`modules-58-${i}`"
        :style="{boxShadow: `0 3px 10px 0 ${getShadowColor(path)}`, borderColor: `${getPageThemeColor(path)}`}"
        class="item"
        :class="{'marTop': i & 2 !== 0}"
        @click="onModuleItem(v)"
      >
        <el-image class="item-avator" :src="v.photo | imgPath" alt="avator" />
        <p class="h-line-1 item-name">{{ v.name || '' }}</p>
        <p class="h-line-1 item-post">{{ v.post || '' }}</p>
        <p class="item-phone">
          {{ v.phoneShow ? v.phone : hiddenPhone(v.phone) }}
          <span @click.stop="onPhoneHidden(v)">{{ v.phoneShow ? '隐藏' : '显示' }}</span>
        </p>
        <div class="item-retanc" :style="{backgroundColor: `${getPageThemeColor(path)}`}"></div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modules-id-59-content {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 20px;
}
.item {
  width: 160px;
  height: 260px;
  background-color: #fff;
  border: 1px solid;
  padding: 0 10px;
  box-sizing: border-box;
  box-shadow: 0px 4px 15px 0px rgba(23,23,23,0.1);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  .item-avator {
    width: 76px;
    height: 100px;
    border-radius: 2px;
    margin-top: 24px;
  }
  .item-name, .item-post {
    width: 120px;
    color: #000;
    text-align: center;
    margin-top: 16px;
  }
  .item-name {
    font-size: 17px;
    font-weight: bold;
  }
  .item-post {
    font-size: 14px;
  }
  .item-phone {
    font-size: 13px;
    margin-top: 10px;
    text-align: center;
    span {
      color: #999;
      cursor: pointer;
    }
  }
  .item-retanc {
    position: absolute;
    bottom: 0;
    width: 71px;
    height: 6px;
    border-radius: 5px 5px 0px 0px;
  }
}
.marTop {
  margin-top: 30px;
}
</style>
